"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tectonic_contract_types_1 = require("@cronos-labs/tectonic-contract-types");
const base_1 = require("../base");
class OracleModule extends base_1.TectonicSDKModule {
    async tokenPriceInUsd(tTokenAddress) {
        // TODO: Check if token is supported
        const tCore = this.getTectonicCore();
        const oracleAddress = await tCore.oracle();
        const oracle = tectonic_contract_types_1.PriceOracleFactory.connect(oracleAddress, this.provider);
        return oracle.getUnderlyingPrice(tTokenAddress);
    }
    async tokenPriceInUsdFromCronosOracleRegistry(tokenAddress) {
        const oracle = this.getCronosOracleRegistry();
        return oracle.getPrice(tokenAddress);
    }
    async address() {
        const tCore = this.getTectonicCore();
        const oracleAddress = await tCore.oracle();
        return oracleAddress;
    }
}
exports.default = OracleModule;
//# sourceMappingURL=oracle.js.map